import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

const stateMaping = {
  S1: 'F1',
  S2: 'F2',
  S3: 'F3',
  S4: 'F4',
  S5: 'F5',
  S6: 'F6',
  S7: 'F7',
  S8: 'F8',
  S9: 'F9',
  S10: 'F10',
  S11: 'F11',
  S12: 'F12',
  S13: 'F13',
  S14: 'F14',
};

export const useBroadcast = () => {
  const { user, carousel, repeatCount, startFrom, duration } = useGetParams();

  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [currentMessage, setCurrentMessage] = useState(null);
  const messageAnimationTriggerRef = useRef(false);

  const lastMessageIdRef = useRef(0);
  const nextMessageIndexRef = useRef(-1);
  const messagesRef = useRef([]);

  const allMessagesRef = useRef([]);

  const protocol = window?.location.protocol || 'https:';

  // задержка интервала смены сообщений
  const [delay, setDelay] = useState(duration);
  // id предыдущего запущенного интерактива
  const prevIdBroadcast = useRef('');
  // id текущего запущенного интерактива
  const iactiveIdRef = useRef('');

  const getBroadcastInfo = async () => {
    try {
      if (!user) {
        return;
      }

      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();

      if (!data) return;

      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // очистка при остановке\смене интерактива, при остановке iactiveId = ""
      if (iactiveIdRef.current !== iactiveId) {
        if (
          currentMessage &&
          iactiveId &&
          iactiveId !== prevIdBroadcast.current // если === , значит prevIdBroadcast был остановлен и теперь запущен, и не нужно обнулять
        ) {
          messagesRef.current = [];
          allMessagesRef.current = [];
          setCurrentMessage(null);
          nextMessageIndexRef.current = -1;
        }
      }

      // сохранение id нового запущенного интерактива.
      if (iactiveId && iactiveId !== prevIdBroadcast.current) {
        // Если уже был предыдущий запущенный интерактив, то показать сообщение сразу без задержки.
        if (prevIdBroadcast.current) {
          // console.log('смена интреактива');
          setDelay(1000);
        }
        prevIdBroadcast.current = iactiveId;
      }

      // Определяем видимость титра

      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Определяем состояние (S1, S2 ...)

      messagesList = messagesList.filter((m) => m.message.content);

      let result = [];
      messagesList.forEach((el) => {
        if (
          typeof el.message?.attachments?.[0] === 'object' &&
          el.message?.attachments?.[0]?.url &&
          !allMessagesRef.current.find(
            (elm) =>
              typeof elm.message.attachments?.[0] === 'object' &&
              typeof el.message.attachments?.[0] === 'object' &&
              elm.message.attachments?.[0]?.url ===
                el.message.attachments?.[0]?.url,
          )
        ) {
          result.push(el);
        } else if (
          !allMessagesRef.current.find(
            (elm) =>
              elm.message.content === el.message.content &&
              elm.message.author === el.message.author,
          )
        ) {
          result.push(el);
        }
      });

      allMessagesRef.current = [
        ...result,
        ...allMessagesRef.current.filter(
          (el) => !deletedMessagesIdList.includes(+el.id),
        ),
      ].slice(-repeatCount);

      messagesRef.current = allMessagesRef.current
        .filter((m) => m.titrTag === stateMaping[currentState])
        .map((mes) => ({
          ...mes,
          UUID: crypto.randomUUID(),
        }));

      let newState =
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state);

      if (newState && newState !== currentState) {
        setCurrentState(newState);
        setCurrentMessage(null);

        messagesRef.current = allMessagesRef.current.filter(
          (m) => m.titrTag === stateMaping[newState],
        );

        nextMessageIndexRef.current = -1;

        if (currentState) {
          setDelay(1000);
        }
      }

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const iterateIndex = (array) => {
    if (carousel === '1') {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messagesRef.current.length >= startFrom) {
          messagesRef.current = messagesRef.current.slice(-repeatCount);
          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messagesRef.current.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messagesRef.current.length - 1;
      }
    }
  };

  useEffect(() => {
    getBroadcastInfo().then(() => {
      if (messagesRef.current && messagesRef.current.length > 0) {
        iterateIndex(messagesRef.current);
        setCurrentMessage(messagesRef.current[nextMessageIndexRef.current]);
      }
    });
  }, []);

  // Выбор сообщения для показа
  useInterval(
    () => {
      iterateIndex(messagesRef.current);

      if (
        messagesRef.current &&
        messagesRef.current.length === 0 &&
        currentMessage !== null
      ) {
        setCurrentMessage(null);
      } else if (
        messagesRef.current &&
        messagesRef.current.length > 0 &&
        (!currentMessage ||
          (currentMessage &&
            currentMessage.id !==
              messagesRef.current[nextMessageIndexRef.current].UUID))
      ) {
        setCurrentMessage({
          ...messagesRef.current[nextMessageIndexRef.current],
          UUID: crypto.randomUUID,
        });
        messageAnimationTriggerRef.current =
          !messageAnimationTriggerRef.current;

        // добавление задержки интервалу, после отработки по (delay === 1000)
        if (delay === 1000) {
          setDelay(duration);
        }
      }
    },
    isVisible && currentState ? delay : null,
  );

  // Получение информации о титре
  useInterval(getBroadcastInfo, 1000);

  return {
    currentState,
    isVisible,
    currentMessage,
    messageAnimationTrigger: messageAnimationTriggerRef.current,
    setDelay,
    delay,
  };
};
